import React from "react";
import RFQScreen from "../RFQScreen";

/**
 * Generic material subcategory component
 * @param {string} categoryName - The parent category name (e.g., "Concrete")
 * @param {string} subcategoryName - The subcategory name (e.g., "Liquid")
 * @param {string} unit - The unit of measurement
 * @param {string} unitCode - The unit code
 * @param {Array} dealers - List of dealers
 */
export default function MaterialComponent({ 
  categoryName, 
  subcategoryName, 
  unit, 
  unitCode,
  dealers = [],
  clientId
}) {
  // Generate API endpoint dynamically based on category and subcategory
  const apiEndpoint = `/api/rfq/${categoryName.toLowerCase().replace(/\s+/g, '-')}/${subcategoryName.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <RFQScreen
      title={`${subcategoryName} ${categoryName} RFQ`}
      unit={unit}
      apiEndpoint={apiEndpoint}
      dealers={dealers}
      placeholder={`Enter ${unit}...`}
      clientId={clientId}
      materialCategory={categoryName}
      materialSubcategory={subcategoryName}
    />
  );
}